// extracted by mini-css-extract-plugin
module.exports = {"example":"_2XPwzOIbQMFq_lQmv6H0ll"};